export const useT = (key: string, params?: Record<string, string | number>) => {
  return useNuxtApp().$i18n.t(key, params ?? {});
};
